import { getDeviceId, getDeviceType } from '@crunchyroll/web-auth-utils';

import API from 'app/api';
import { deviceIdDomain } from 'config/baseconfig';

const createToken = ({ isUserAuthenticated, anonymousId, countryCode }) => {
  const {
    cxApiParams: { accountAuthClientId, anonClientId },
  } = window.etp.config;

  const deviceId = getDeviceId(deviceIdDomain);
  const deviceType = getDeviceType();

  const headers = {
    Authorization: `Basic ${window.btoa(
      `${isUserAuthenticated ? accountAuthClientId : anonClientId}:`,
    )}`,
    'ETP-Anonymous-Id': anonymousId,
    'ETP-Viewer-Country-Override': countryCode,
  };
  const grantType = isUserAuthenticated
    ? 'grant_type=etp_rt_cookie'
    : 'grant_type=client_id';

  const data = [grantType];

  data.push(`device_id=${deviceId}`);
  data.push(`device_type=${deviceType}`);

  return API.Auth.createToken(data.join('&'), { headers });
};

export { createToken };
